import { Anexo } from "../../types";
import CardAnexo from "./CardAnexo";

interface BlocoAnexosProps {
    anexos: Anexo[];
    onNavigateToFile?: (fileId: number) => void;
}

export default function BlocoAnexos({ anexos, onNavigateToFile }: BlocoAnexosProps) {
    if (anexos.length === 0) {
        return null;
    }

    return (
        <div className="expanded-section">
            <h4 className="section-title">Anexos</h4>
            <div className="anexos-container">
                {anexos.map((anexo, idx) => (
                    <CardAnexo key={anexo.id || `${anexo.filename}-${idx}`} anexo={anexo} onNavigateToFile={onNavigateToFile} />
                ))}
            </div>
        </div>
    );
}

